<template>
  <div>
    <button v-if="cjpBudget" class="button--primary" @click="openPopup">
      <i class="icon fas fa-shopping-basket"></i>{{ buttonText }}
    </button>
    <a
      v-if="!cjpBudget"
      id="scoor-deal-checkout-tablet"
      class="button--primary"
      :target="external ? '_blank' : '_self'"
      @click="openLink"
    >
      <i class="icon fas fa-shopping-basket"></i>
      {{ activeButtonText }}
    </a>
  </div>
</template>

<script>
import user from "../services/userServices/userService";
import EventBus from "./../event-bus";
import { hasProductAvailability } from "../helpers/productAvailabilityHelper";

export default {
  name: "OrderNowButton",
  props: {
    cjpBudget: {
      type: Boolean,
      required: false,
      default: false,
    },
    checkoutUrl: {
      type: String,
      required: false,
      default: "",
    },
    buttonText: {
      type: String,
      required: true,
    },
    external: {
      type: Boolean,
      required: false,
      default: false,
    },
    activeMembershipRequired: {
      type: String,
      required: false,
      default: "false",
    },
    availabilityCheck: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isLoggedIn: false,
      isActiveMembershipRequired: false,
      activeButtonText: "",
    };
  },
  async mounted() {
    this.activeButtonText = this.buttonText;

    if (this.activeMembershipRequired === "true") {
      this.isActiveMembershipRequired = true;
    }
    EventBus.$on("loggedIn", (event) => {
      if (event === false) {
        this.isLoggedIn = false;
      }
    });

    try {
      this.isLoggedIn = await user.isAuthenticated();
      this.hasActiveMembership = await user.hasActiveMembership();
      if (this.hasActiveMembership === "false") {
        this.hasActiveMembership = false;
      }
    } catch (e) {
      this.isLoggedIn = false;
    }
  },
  methods: {
    openPopup() {
      if (
        this.isLoggedIn &&
        ((this.hasActiveMembership && this.isActiveMembershipRequired) ||
          !this.isActiveMembershipRequired)
      ) {
        return EventBus.$emit("openPopupSpendBudget", false);
      } else if (this.isLoggedIn === false) {
        this.navigateViaLogin();
      } else {
        EventBus.$emit("openPopupActiveMembershipRequired", false);
        return false;
      }
    },
    navigateViaLogin() {
      const host = window.location.hostname.split(".");
      host[0] = "mijn";
      if (host.length > 2) {
        window.location.href =
          window.location.protocol +
          "//" +
          host.join(".") +
          "/login?product=" +
          location.pathname;
      } else {
        window.location.href =
          "https://mijn.cjp.nl/login?product=" + location.pathname;
      }
    },
    async openLink() {
      if (
        this.isLoggedIn &&
        ((this.hasActiveMembership && this.isActiveMembershipRequired) ||
          !this.isActiveMembershipRequired)
      ) {
        if (this.availabilityCheck) {
          const oldButtonText = this.activeButtonText;
          this.activeButtonText = "Bezig...";
          const check = JSON.parse(this.availabilityCheck);
          const availability = await this.hasAvailability(check);
          if (
            availability === false ||
            (typeof availability === "object" && availability.count === 0)
          ) {
            EventBus.$emit("openPopupAvailabilityCheck", {
              reason: availability.reason,
              reasonCode: availability.reasonCode,
            });
            this.activeButtonText = oldButtonText;
            return;
          }
          this.activeButtonText = oldButtonText;
        }
        if (window.location.hostname.indexOf("educatie") !== -1) {
          EventBus.$emit("openPopupEducationServiceRedirect", false);
        } else if (this.external) {
          return window.open(this.checkoutUrl, "_blank");
        } else {
          window.location.href = this.checkoutUrl;
        }
      } else if (this.isLoggedIn === false) {
        if (this.external) {
          // For external, redirect to current page and let user click deeplink again.
          this.navigateViaLogin();
        } else {
          // For internal links, also let user come back to this page and click the checkout link again.
          // This forces availability check or membership check.
          this.navigateViaLogin();
          return false;
        }
      } else {
        EventBus.$emit("openPopupActiveMembershipRequired", false);
        return false;
      }
    },
    async hasAvailability({ slug, type }) {
      return await hasProductAvailability({ slug, type });
    },
  },
};
</script>
